var _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVennIllus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.65,
    cx: 29,
    cy: 29,
    rx: 29,
    ry: 29,
    transform: "rotate(-90 29 29)",
    fill: "#FCE400"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    cx: 29.2815,
    cy: 29.2369,
    rx: 15.8068,
    ry: 15.8068,
    transform: "rotate(-90 29.2815 29.2369)",
    fill: "#FCE400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVennIllus);
export default __webpack_public_path__ + "static/media/Venn Illus.6a072ee73ec917a85fa3e62653304b59.svg";
export { ForwardRef as ReactComponent };